import React, { Fragment } from 'react';
import { TextPlaceholder } from "../../../elements/TextPlaceholder";
import { Divider } from "../../../elements/Divider";
export var getCurrencyDropdownPlaceholderMarkup = function getCurrencyDropdownPlaceholderMarkup() {
  return React.createElement(Fragment, null, React.createElement(TextPlaceholder, {
    length: "full"
  }), React.createElement(TextPlaceholder, {
    length: "full"
  }), React.createElement(Divider, null));
};